import {
  getAbandonedCheckout as publicGetAbandonedCheckout,
  deleteAbandonedCheckout as publicDeleteAbandonedCheckout,
  bulkDeleteAbandonedCheckouts as publicBulkDeleteAbandonedCheckouts,
  queryAbandonedCheckouts as publicQueryAbandonedCheckouts,
  typedQueryAbandonedCheckouts as publicTypedQueryAbandonedCheckouts,
  searchAbandonedCheckouts as publicSearchAbandonedCheckouts,
  addAbandonedCheckoutActivity as publicAddAbandonedCheckoutActivity,
  getAbandonedCheckoutAnalytics as publicGetAbandonedCheckoutAnalytics,
  redirectToCheckout as publicRedirectToCheckout,
} from './ecom-v1-abandoned-checkout-abandoned-checkouts.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  AbandonedCheckoutQuery,
  AbandonedCheckoutsQueryBuilder,
  typedQueryAbandonedCheckouts as universalTypedQueryAbandonedCheckouts,
} from './ecom-v1-abandoned-checkout-abandoned-checkouts.universal.js';
import { onAbandonedCheckoutCreated as publicOnAbandonedCheckoutCreated } from './ecom-v1-abandoned-checkout-abandoned-checkouts.public.js';
import { onAbandonedCheckoutDeleted as publicOnAbandonedCheckoutDeleted } from './ecom-v1-abandoned-checkout-abandoned-checkouts.public.js';
import { onAbandonedCheckoutRecovered as publicOnAbandonedCheckoutRecovered } from './ecom-v1-abandoned-checkout-abandoned-checkouts.public.js';
import { onAbandonedCheckoutUpdated as publicOnAbandonedCheckoutUpdated } from './ecom-v1-abandoned-checkout-abandoned-checkouts.public.js';

function customQueryAbandonedCheckouts(httpClient: HttpClient) {
  const router = /*#__PURE__*/ createQueryOverloadRouter({
    builderQueryFunction: () => publicQueryAbandonedCheckouts(httpClient)(),
    typedQueryFunction: (query: AbandonedCheckoutQuery) =>
      publicTypedQueryAbandonedCheckouts(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): AbandonedCheckoutsQueryBuilder;
  function overloadedQuery(
    query: AbandonedCheckoutQuery
  ): ReturnType<typeof universalTypedQueryAbandonedCheckouts>;
  function overloadedQuery(query?: AbandonedCheckoutQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const getAbandonedCheckout: MaybeContext<
  BuildRESTFunction<typeof publicGetAbandonedCheckout> &
    typeof publicGetAbandonedCheckout
> = /*#__PURE__*/ createRESTModule(publicGetAbandonedCheckout);
export const deleteAbandonedCheckout: MaybeContext<
  BuildRESTFunction<typeof publicDeleteAbandonedCheckout> &
    typeof publicDeleteAbandonedCheckout
> = /*#__PURE__*/ createRESTModule(publicDeleteAbandonedCheckout);
export const bulkDeleteAbandonedCheckouts: MaybeContext<
  BuildRESTFunction<typeof publicBulkDeleteAbandonedCheckouts> &
    typeof publicBulkDeleteAbandonedCheckouts
> = /*#__PURE__*/ createRESTModule(publicBulkDeleteAbandonedCheckouts);
export const searchAbandonedCheckouts: MaybeContext<
  BuildRESTFunction<typeof publicSearchAbandonedCheckouts> &
    typeof publicSearchAbandonedCheckouts
> = /*#__PURE__*/ createRESTModule(publicSearchAbandonedCheckouts);
/** @internal */
export const addAbandonedCheckoutActivity: MaybeContext<
  BuildRESTFunction<typeof publicAddAbandonedCheckoutActivity> &
    typeof publicAddAbandonedCheckoutActivity
> = /*#__PURE__*/ createRESTModule(publicAddAbandonedCheckoutActivity);
export const getAbandonedCheckoutAnalytics: MaybeContext<
  BuildRESTFunction<typeof publicGetAbandonedCheckoutAnalytics> &
    typeof publicGetAbandonedCheckoutAnalytics
> = /*#__PURE__*/ createRESTModule(publicGetAbandonedCheckoutAnalytics);
export const redirectToCheckout: MaybeContext<
  BuildRESTFunction<typeof publicRedirectToCheckout> &
    typeof publicRedirectToCheckout
> = /*#__PURE__*/ createRESTModule(publicRedirectToCheckout);
export const queryAbandonedCheckouts: MaybeContext<
  BuildRESTFunction<typeof customQueryAbandonedCheckouts> &
    typeof customQueryAbandonedCheckouts
> = /*#__PURE__*/ createRESTModule(customQueryAbandonedCheckouts);
/**
 * Triggered when an abandoned checkout is created.
 */
export const onAbandonedCheckoutCreated: BuildEventDefinition<
  typeof publicOnAbandonedCheckoutCreated
> &
  typeof publicOnAbandonedCheckoutCreated = /*#__PURE__*/ createEventModule(
  publicOnAbandonedCheckoutCreated
);
/**
 * Triggerred when an abandoned checkout is deleted.
 */
export const onAbandonedCheckoutDeleted: BuildEventDefinition<
  typeof publicOnAbandonedCheckoutDeleted
> &
  typeof publicOnAbandonedCheckoutDeleted = /*#__PURE__*/ createEventModule(
  publicOnAbandonedCheckoutDeleted
);
/**
 * Triggered when an abandoned checkout is recovered.
 */
export const onAbandonedCheckoutRecovered: BuildEventDefinition<
  typeof publicOnAbandonedCheckoutRecovered
> &
  typeof publicOnAbandonedCheckoutRecovered = /*#__PURE__*/ createEventModule(
  publicOnAbandonedCheckoutRecovered
);
/**
 * Triggered when an abandoned checkout is updated.
 */
export const onAbandonedCheckoutUpdated: BuildEventDefinition<
  typeof publicOnAbandonedCheckoutUpdated
> &
  typeof publicOnAbandonedCheckoutUpdated = /*#__PURE__*/ createEventModule(
  publicOnAbandonedCheckoutUpdated
);

export {
  ActivityType,
  Status,
  VatType,
  DescriptionLineType,
  DimensionsUnit,
  DiscountType,
  Identity,
  SortOrder,
  CommonSortOrder,
  Mode,
  Metric,
  WebhookIdentityType,
} from './ecom-v1-abandoned-checkout-abandoned-checkouts.universal.js';
export {
  AbandonedCheckout,
  V1BuyerInfo,
  V1BuyerInfoIdOneOf,
  FullAddressContactDetails,
  VatId,
  MultiCurrencyPrice,
  Activity,
  LineItem,
  CatalogReference,
  ProductName,
  DescriptionLine,
  DescriptionLineValueOneOf,
  DescriptionLineDescriptionLineValueOneOf,
  DescriptionLineName,
  PlainTextValue,
  Color,
  PhysicalProperties,
  Dimensions,
  AppliedDiscount,
  AppliedDiscountDiscountSourceOneOf,
  Coupon,
  MerchantDiscount,
  DiscountRule,
  DiscountRuleName,
  CartAbandonedEvent,
  BuyerInfo,
  Totals,
  CartRecoveredEvent,
  AbandonedCheckoutRecovered,
  GetAbandonedCheckoutRequest,
  GetAbandonedCheckoutResponse,
  DeleteAbandonedCheckoutRequest,
  DeleteAbandonedCheckoutResponse,
  BulkDeleteAbandonedCheckoutsRequest,
  BulkDeleteAbandonedCheckoutsResponse,
  ItemMetadata,
  ApplicationError,
  BulkAbandonedCheckoutResult,
  BulkActionMetadata,
  QueryAbandonedCheckoutsRequest,
  QueryV2,
  QueryV2PagingMethodOneOf,
  Sorting,
  AddressLocation,
  Paging,
  CursorPaging,
  QueryAbandonedCheckoutsResponse,
  PagingMetadataV2,
  Cursors,
  SearchAbandonedCheckoutsRequest,
  Search,
  SearchPagingMethodOneOf,
  CommonSorting,
  SearchDetails,
  CommonPaging,
  CommonCursorPaging,
  SearchAbandonedCheckoutsResponse,
  CommonPagingMetadataV2,
  CommonCursors,
  AddAbandonedCheckoutActivityRequest,
  AddAbandonedCheckoutActivityResponse,
  GetAbandonedCheckoutAnalyticsRequest,
  GetAbandonedCheckoutAnalyticsResponse,
  Task,
  TaskKey,
  TaskAction,
  TaskActionActionOneOf,
  Complete,
  Cancel,
  Reschedule,
  RedirectToCheckoutRequest,
  RawHttpResponse,
  HeadersEntry,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  Empty,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  AbandonedCheckoutCreatedEnvelope,
  AbandonedCheckoutDeletedEnvelope,
  AbandonedCheckoutRecoveredEnvelope,
  AbandonedCheckoutUpdatedEnvelope,
  AbandonedCheckoutsQueryResult,
  AbandonedCheckoutsQueryBuilder,
  AbandonedCheckoutQuerySpec,
  AbandonedCheckoutSearchSpec,
  AddAbandonedCheckoutActivityOptions,
  GetAbandonedCheckoutAnalyticsOptions,
} from './ecom-v1-abandoned-checkout-abandoned-checkouts.universal.js';
export { utils } from './ecom-v1-abandoned-checkout-abandoned-checkouts.universal.js';
export {
  ActivityTypeWithLiterals,
  StatusWithLiterals,
  VatTypeWithLiterals,
  DescriptionLineTypeWithLiterals,
  DimensionsUnitWithLiterals,
  DiscountTypeWithLiterals,
  IdentityWithLiterals,
  SortOrderWithLiterals,
  CommonSortOrderWithLiterals,
  ModeWithLiterals,
  MetricWithLiterals,
  WebhookIdentityTypeWithLiterals,
  CommonQueryWithEntityContext,
  AbandonedCheckoutQuery,
  CommonSearchWithEntityContext,
  AbandonedCheckoutSearch,
} from './ecom-v1-abandoned-checkout-abandoned-checkouts.universal.js';
